import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { clearStore as clearStoreAction } from 'features/store';

const useStore = () => {
  const dispatch = useDispatch();
  const clearStore = useCallback(() => dispatch(clearStoreAction()), [dispatch]);

  return { clearStore };
};

export default useStore;
